import Box from '@mui/material/Box'
import logoutBoxy from '../../svg/boxyIcons/logoutBoxy.svg'
import logoutModern from '../../svg/modernIcons/logoutModern.svg'
import SignOut from '../SignOut'

const LogOutIcon = () => {
    const iconSelect = localStorage.getItem('iconsSelect')
    const icon = iconSelect === 'Boxy'
        ? <img src={logoutBoxy} alt='Log Out' />
        : iconSelect === 'Modern'
            ? <img src={logoutModern} alt='Log Out' />
            : <SignOut />

    return (
        <Box
            sx={{
                alignItems: 'center',
                display: 'flex',
                marginRight: '5px',
                width: '28px',
                '& svg': { maxHeight: '24px', width: '30px' }
            }}
        >
            {icon}
        </Box>
    )
}

export default LogOutIcon
